import React from 'react';

const EmptySiteGroups = () => (
  <div className="no-data-message flex-column">
    <h1>No Site Groups found. Create your first site group.</h1>
    <p>If you do have created site groups, please contact support </p>
  </div>
);

export default EmptySiteGroups;